"use client";
import useMobileDetect from "@/hooks/useMobileDetect";
import { useEffect, useRef, useState } from "react";
import Image from "next/image";
import { handleCardClick } from "@/utils/tools";
import ImageWithSkeleton from "@/app/components/common/ImageWithSkeleton";

type mediaCardListProps = {
  isFirstMobile?: boolean,
  list: {
    name: string,
    pic_description: string,
    button_name?: string,
    h5_pic: string,
    pc_pic: string,
    pic?: string,
    alt_text: string,
    link_type?: number,
    link?: string,
    open_type?: number,
  }[],
  title?: string
}
export const FourPicturesText: React.FC<mediaCardListProps> = ({ isFirstMobile, list, title }) => {

  const isMobile = useMobileDetect(isFirstMobile);
  const imgNumberTOSize_Mobile = ["0.88/1", '112%']
  const _renderPcCardContent = () => {
    return (
      <div className="grid grid-cols-3 gap-x-16" key="pcCardContent">
        {
          list?.map((item, index: number) => {
            return handleCardClick({ ...item, idx: index }, (
              <div
                key={"pcCardItem" + index}
              >
                {item?.pc_pic && (
                  <div className={`relative w-full`}
                  style={{aspectRatio: item?.pic ? imgNumberTOSize_Mobile[0] : '1/1', paddingTop: item?.pic ? imgNumberTOSize_Mobile[1] : '100%'}}
                  >
                    <ImageWithSkeleton
                      src={process.env.NEXT_PUBLIC_IMAGE_URL + item?.pc_pic}
                      alt={item?.alt_text}
                      width={100}
                      height={100}
                    />
                  </div>
                )}
                {
                  item?.pic ? <div className="relative w-28 h-28 mt-24">
                    <ImageWithSkeleton
                      src={process.env.NEXT_PUBLIC_IMAGE_URL + item?.pic}
                      alt={item?.alt_text}
                      width={100}
                      height={100}
                    />
                  </div> : null
                }
                <h2 className={`leading-30 text-bravve-100 ${item?.pic ? 'mt-12' : 'mt-24'} text-3xl`}>
                  {item?.name}
                </h2>
                <div className="leading-24 text-bravve-100 mt-12 text-base h-[94px] line-clamp-4 w-2/3">
                  {item?.pic_description}
                </div>
                {
                  item?.button_name ? <div className="leading-24 text-bravve-100 mt-12 text-base underline">
                    {item?.button_name}
                  </div> : null
                }
              </div>
            ), isMobile)
          })
        }
      </div>
    );
  };

  const _renderMobileCardContent = () => {
    return (
      <div className="flex flex-nowrap overflow-x-scroll" key="mobileCardContent">
        {
          list?.map((item, index: number) => {
            return handleCardClick({ ...item, idx: index }, (
              <div
                key={"mobileCardItem" + index}
                style={{ marginRight: 16 }}
              >
                {item?.h5_pic && (
                  <div className={`relative w-[320px] ${item?.pic ? 'h-[362px]' : 'h-[320px]'}`}>
                    <ImageWithSkeleton
                      src={process.env.NEXT_PUBLIC_IMAGE_URL + item?.h5_pic}
                      alt={item?.alt_text}
                      width={100}
                      height={100}
                    />
                  </div>
                )}
                {
                  item?.pic ? <div className="relative w-28 h-28 mt-24">
                    <ImageWithSkeleton
                      src={process.env.NEXT_PUBLIC_IMAGE_URL + item?.pic}
                      alt={item?.alt_text}
                      width={100}
                      height={100}
                    />
                  </div> : null
                }
                <h2 className={`leading-30 text-bravve-100 ${item?.pic ? 'mt-12' : 'mt-24'} text-3xl`}>
                  {item?.name}
                </h2>
                <div className="leading-24 text-bravve-100 mt-12 text-base h-[120px] line-clamp-4">
                  {item?.pic_description}
                </div>
                {
                  item?.button_name ? <div className="leading-24 text-bravve-100 mt-16 text-base underline">
                    {item?.button_name}
                  </div> : null
                }
              </div>
            ), isMobile)
          })}
      </div>
    );
  };


  return <div
    key="FourPicturesText"
  >
    {
      title ?
        <div
          key="FourPicturesTextTitle"
          className="font-bold text-bravve-100"
          style={{
            fontSize: isMobile ? 22 : 28,
            lineHeight: isMobile ? '30px' : '32px',
            marginBottom: isMobile ? '24px' : '32px',
          }}
        >
          {title}
        </div>
        :
        null
    }
    {isMobile ? <div key="mobileFourPicturesText">{_renderMobileCardContent()}</div> : <div key="pcFourPicturesText">{_renderPcCardContent()}</div>}
  </div>
}